import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ListVehicleDataType } from '../../../models/dashboard/driver-list/list-vehicle';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useListVehicle = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onListVehicleError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while creating drivers account.',
    );
  };

  const onListVehicleSuccess = (resetFn: (...args: any) => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Vehicle listed successfully.');
    resetFn();
  };

  const listVehicle = (data: ListVehicleDataType, resetFn: (...args: any) => void) => {
    const url: HttpConfig = {
      url: 'api/v1/fleets',
      method: 'post',
      data: data,
    };
    request(url, onListVehicleSuccess(resetFn), setLoading, onListVehicleError);
  };

  return { listVehicle, loading };
};

export default useListVehicle;
